import {React} from 'react'
import About from '../Components/About/About'
import Footer from '../Components/Footer/Footer'

function AboutPage(props) {

  return (
    <div>
        <About></About>
        <Footer></Footer>
    </div>
  )
}

export default AboutPage